<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 返回按钮 -->
    <div
      class="topReturnLink w60 fw-600 color0063ea f16 pdb-10 cursor"
      @click="$router.push('/waterCard/receiverRecord')"
    >
      <i class="el-icon-arrow-left fw-600"></i>
      返回
    </div>
    <!-- 表单查询 -->
    <el-form :inline="true" ref="form" :model="form" label-width="80px">
      <el-form-item label="手机号">
        <el-input v-model="form.phone" placeholder="请输入手机号"></el-input>
      </el-form-item>
      <el-form-item label="新卡卡号">
        <el-input v-model="form.cardNo" placeholder="请输入新卡卡号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getInfo()">查询</el-button>
        <el-button @click="reset">重置</el-button>
      </el-form-item>
    </el-form>

    <!-- 表格 -->
    <el-table :data="tableData" border stripe style="width: 100%">
      <el-table-column
        type="index"
        :index="indexMethod"
        label="序号"
        width="50"
        fixed="left"
      >
      </el-table-column>
      <el-table-column prop="cardUserName" label="水卡用户名称">
        <template slot-scope="scope">
          <span
            v-text="scope.row.cardUserName ? scope.row.cardUserName : '- -'"
          ></span>
        </template>
      </el-table-column>
      <el-table-column prop="cardUserPhone" label="手机号">
        <template slot-scope="scope">
          <span
            v-text="scope.row.cardUserPhone ? scope.row.cardUserPhone : '- -'"
          ></span>
        </template>
      </el-table-column>
      <el-table-column prop="oldCard" label="旧卡卡号">
        <template slot-scope="scope">
          <span v-text="scope.row.oldCard ? scope.row.oldCard : '- -'"></span>
        </template>
      </el-table-column>
      <el-table-column prop="newCard" label="新卡卡号">
        <template slot-scope="scope">
          <span v-text="scope.row.newCard ? scope.row.newCard : '- -'"></span>
        </template>
      </el-table-column>
      <el-table-column prop="money" label="接卡金额（元）"> </el-table-column>
      <el-table-column prop="remark" label="接卡备注">
        <template slot-scope="scope">
          <span v-text="scope.row.remark ? scope.row.remark : '- -'"></span>
        </template>
      </el-table-column>
      <el-table-column prop="createName" label="操作人"> </el-table-column>
      <el-table-column prop="createTime" label="创建时间"> </el-table-column>
    </el-table>
    <!-- 分页器 -->
    <el-pagination
      class="mgt-20"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[5, 20, 30, 40, 50]"
      :page-size="pageSize"
      layout=" prev, pager, next"
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
export default {
  components: {
    breadcrumbs,
  },
  data() {
    return {
      form: {},
      tableData: [],
      // 分页数据
      page: 1, // 当前页，默认
      pageSize: 20, //每页显示多少条数据，默认
      total: 50, // 数据总条数
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    getInfo(pageNum) {
      if (!pageNum) {
        this.page = 1;
      }
      this.$api.waterCard
        .projectDetail({
          pageNum: this.page,
          pageSize: this.pageSize,
          receiveId: this.$route.query.id,
          phone: this.form.phone,
          cardNo: this.form.cardNo,
        })
        .then((res) => {
          if (res.code === 200) {
            this.tableData = res.data.rows;
            this.total = res.data.total;
          }
        });
    },
    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChange(val) {
      this.pageSize = val;
      this.getInfo(this.page);
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChange(val) {
      this.page = val;
      this.getInfo(this.page);
    },
    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },
    reset() {
      this.form = {};
      this.getInfo();
    },
  },
};
</script>

<style lang="scss" scoped></style>
